<template>
<div style="width:100%">
  <div v-if="showSelectAll" style="display:flex; align-items:flex-end;flex-direction:column; margin-top:-1.5em;">
    <div>
      <label class="md-check"> 
        전체선택
        <input type="checkbox" v-model="selectAll" @change="checkboxChange" :disabled="disabled">
        <i class="black"></i>
      </label>   
    </div>
  </div>
  <div class="form-input" v-if="formEdit">
    <Multiselect 
    ref="multiselect"
    v-bind="$attrs"
    v-model="selectedValues" 
    :label="label" :track-by="trackBy"
    :loading="isLoading"
    :internal-search="false"

    :clear-on-select="clearOnSelect"
    :multiple="multiple"
    :open-direction="openDirection"
    :placeholder="placeholder"
    :limit="limit"
    :options="dataOptions" 
    :searchable="true"
    :limit-text="limitText" 
    :max-height="190" 
    :show-no-results="false" 
    :hide-selected="false"
    :select-label="selectLabel"
    :show-labels="showLabels"
    :option-height="optionHeight"
    @select="selectEvent"
    @remove="removeEvent"
    @search-change="getData"
    @close="closedEvent"
    @input="changeEvent">
    <!--template slot="option" slot-scope="props">
      <component v-bind:is="optionTemplate" :props="props"/> 
    </template-->
    </Multiselect>
    <i class="icon-solidIcon-confirm" v-on:click="confirmInput" v-if="editMode"><span class="blind">확인</span></i>
    <i class="icon-solidIcon-cancel" v-on:click="cancelInput" v-if="editMode"><span class="blind">취소</span></i>
  </div>
  <div v-if="!formEdit">
    <div class="form-input">
      <span class="input-text">{{display(value)}}</span>
      <i v-if="editMode" v-on:click="modeChange" class="form-label-icon icon-lineIcon-edit"></i>
    </div>
  </div>
</div>

</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  props: {
    optionTemplate: Object,
    value: Array,
    settings: Object,
    url: String,
    selectLabel: {
      type: String,
      default: function() {
        return "select";
      }
    },
    removeLabel: {
      type: String,
      default: function() {
        return "remove";
      }
    },
    label: {
      type: String,
      default: function() {
        return "name";
      }
    },
    initValues: {
      type: Array,
      default: function() {
        return null;
      }
    },
    selectedValues: {
      type: Array,
      default: function() {
        return [];
      }
    },
    dataOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    
    trackBy: {
      type: String,
      default: function() {
        return "id";
      }
    },
    delay: {
      type: Number,
      default: function() {
        return 250;
      }
    },
    optionHeight: {
      type: Number
    },
    showLabels: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isRead: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    loading: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    multiple: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    params: {
      type: Object,
      default: function() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: function() {
        return "검색";
      }
    },
    loadOnSearch: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    fixdData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isAwaysOpen: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    allowEmpty: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    keepSearchText: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    showSelectAll: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    term: {
      type: String,
      default: function() {
        return "term";
      }
    },
    limit: {
      type: Number,
      default: function() {
        return 5;
      }
    },
    limitLength: {
      type: Number,
      default: function() {
        return 1;
      }
    },
    autoResize: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    tagMaxWidth: {
      type: Number,
      default: () => {
        return 13
      }
    },
    openDirection: {
      type: String,
      default: () => {
        return ''
      }
    },
    clearOnSelect: {
      type: Boolean,
      default: function() {
        return true;
      }
    }
  },
  components:{
    Multiselect,
  },
  created(){
  },
  mounted(){
    this.initComponent();
    
  },
  watch:{
    initValues(newVal, oldVal){
      if(oldVal == null && newVal != null){
        this.selectedValues = Object.assign([], this.initValues);
        
      }
    },
  },
  data(){
    return {
      formEdit: true,
      options: [],
      //selectedValues: [],
      tempData: [],
      isLoading: false,
      selectAll: false,
      params: {},
    }
  },
  methods: {
    initComponent() {
      
      this.formEdit = !this.isRead;
      
      if(this.selectedValues == '' || this.selectedValues == null){
        this.tempData = this.selectedValues;
      }else{
        this.tempData = Object.assign({}, this.selectedValues);
      }
      
      this.tempData = Object.assign({}, this.selectedValues);
      //this.selectedValue = this.value;

      if(this.isSelectionFirstData){
        this.selectedValues = this.options[0];
      }

      this.isLoading = this.loading ? true : false;

      if(this.loadOnSearch){
        setTimeout(function(){
          this.getData("", true);
        }.bind(this))
      }

      if(this.isAwaysOpen) {
        this.$refs.multiselect.isOpen = true;
        if(!this.autoResize){
          $(this.$refs.multiselect.$el).attr('style', 'height:auto;max-height:253px');
        }else{
          $(this.$refs.multiselect.$el).attr('style', 'height:auto;');
        }
        $(this.$refs.multiselect.$el).find('.multiselect__select').attr('style', 'display:none');

        $(this.$refs.multiselect.$el).find('.multiselect__tags-wrap').attr('style', 'min-height:50px');
        $(this.$refs.multiselect.$el).find('.multiselect__content-wrapper').attr('style', 'position:initial;height:190px;');
        $(this.$refs.multiselect.$el).find('.multiselect__tags').attr('style', 'min-height:63px');
        $(this.$refs.multiselect.$el).find('.multiselect__strong').attr('style', 'max-width:15%');

                
        
      }

      setTimeout(function(){
        if(this.initValues){
          this.selectedValues = Object.assign([], this.initValues);
        }
      }.bind(this),1000)

    },
    clearAll(){
      setTimeout(function(){
        
        this.$refs.multiselect.search = "";
        this.selectedValues = [];
        this.dataOptions = [];
      }.bind(this), 500)

      $(".multiselect__input").val("");
    },
    limitText (count) {
      return '외' + count + '건'
    },
    getData(query, forceSearch){
      
      if(query != null && (this.limitLength > query.length) && !forceSearch)
        return;
      
      var params = Object.assign({}, this.params);

      params[this.term] = query;
      params = Object.assign(params, this.fixdData)
      this.$http.get(this.url, {params: params})
        .then(function(result) {
          this.dataOptions = result.data.list;
          this.isLoading = false;
        }.bind(this)).catch((e) =>{
          this.isLoading = false;
      })
    },

    closedEvent(event) {
      if(this.isAwaysOpen){
        if(this.keepSearchText)
          var copyText = $(this.$refs.multiselect.$el).find('input').val();
        this.$refs.multiselect.search = copyText;
        this.$refs.multiselect.isOpen = true
        
      }
    },
    changeEvent(event) {

      //this.$emit('change',event);
    },
    selectEvent(event) {
      
      this.$emit('select',event);
      //this.selectedValues.push(Object.assign({}, event))
    },
    removeEvent(event) {
      this.$emit('remove',event);
      //this.selectedValues.push(Object.assign({}, event))
    },
    checkboxChange(event){
      
      this.selectedValues = [];
      if(this.selectAll) {
        this.dataOptions.forEach(function(item, index){
          this.selectedValues.push(item);
        }.bind(this))
      }else{
        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.multiselect__tag{
  max-width: 100%;
}
</style>